
import React from "react";
import "./about.css";
import { SiteHeader as Header, SiteFooter as Footer } from "./chrome.jsx";
import { FaEye, FaBullseye, FaArrowRight } from "react-icons/fa6";

const faqs = [
  {
    q: "What is website development?",
    a: "Website development is the process of creating a professional and responsive website for a business, service, product, or organization.",
  },
  {
    q: "Why does a business need a website?",
    a: "A website helps businesses build an online presence, reach customers, showcase services, generate enquiries, and establish credibility.",
  },
  {
    q: "What is a web application?",
    a: "A web application is an online software system that allows users to perform tasks such as bookings, orders, payments, account management, or accessing dashboards.",
  },
  {
    q: "What is a mobile application?",
    a: "A mobile application gives customers or employees convenient access to services, information, bookings, notifications, and other business features through mobile devices.",
  },
  {
    q: "What is CRM software?",
    a: "CRM software helps businesses manage customers, leads, sales, communication, follow-ups, and customer information from one system.",
  },
  // {
  //   q: "What is a CMS?",
  //   a: "A CMS, or Content Management System, allows businesses to create, manage, and update website content without needing to edit the website code directly.",
  // },
  {
    q: "What is a digital solution?",
    a: "A digital solution is technology designed to solve a specific business need, such as a website, application, CRM, CMS, e-commerce platform, or custom software.",
  },
  {
    q: "How do I know which solution my business needs?",
    a: "It depends on your business goals and requirements. We understand your needs and recommend the most suitable digital solution for your business.",
  },
];

function AboutIntro() {
  return (
    <section className="abt-intro">
      <div className="abt-intro-inner">
        <div className="abt-intro-image">
          <img
            src="https://images.unsplash.com/photo-1521737711867-e3b97375f902?auto=format&fit=crop&w=1000&q=85"
            alt="Technology team collaborating on digital solutions"
          />
          <div className="abt-image-label">
            <span>OUR APPROACH</span>
            <strong>Understand. Create. Improve.</strong>
          </div>
        </div>

        <div className="abt-intro-content">
          <span className="abt-eyebrow">ABOUT US</span>
          <h1>About Hallef Technologies</h1>
          <h2>Building Digital Solutions That Make Business Better</h2>

          <p>
            Hallef Technologies is an IT solutions and software development
            company helping businesses build their digital presence, improve
            operations, and connect with customers through technology.
          </p>

          <p>
            We develop websites, web applications, mobile applications, CRM
            and CMS platforms, e-commerce solutions, and custom software
            based on each business&apos;s requirements.
          </p>

          <a className="abt-primary-btn" href="#abt-vision">
            Discover Our Approach <FaArrowRight />
          </a>
        </div>
      </div>
    </section>
  );
}

function VisionMission() {
  return (
    <section className="abt-vision" id="abt-vision">
      <div className="abt-heading">
        <span className="abt-eyebrow">OUR VISION &amp; MISSION</span>
        <h2>Technology that is practical and valuable for every business.</h2>
      </div>

      <div className="abt-vision-grid">
        <article className="abt-vision-card">
          <div className="abt-icon">
            <FaEye />
          </div>
          <div>
            <span className="abt-card-label">OUR VISION</span>
            <h3>Making technology valuable for every business.</h3>
            <p>
              We aim to become a no. 1 trusted technology partner for
              businesses by creating digital solutions that simplify work,
              improve customer experiences, and support long-term growth.
              Our vision is to make technology practical and valuable for
              businesses of every size.
            </p>
          </div>
        </article>

        <article className="abt-vision-card">
          <div className="abt-icon">
            <FaBullseye />
          </div>
          <div>
            <span className="abt-card-label">OUR MISSION</span>
            <h3>Turning business challenges into digital solutions.</h3>
            <p>
              Our mission is to transform business requirements and
              challenges into reliable digital solutions. We focus on
              modern technology, quality development, clear communication,
              and continuous support to help businesses achieve their
              digital goals.
            </p>
          </div>
        </article>
      </div>
    </section>
  );
}

function FAQ() {
  return (
    <section className="abt-faq" id="abt-faq">
      <div className="abt-faq-inner">
        <div className="abt-faq-intro">
          <span className="abt-eyebrow">FREQUENTLY ASKED QUESTIONS</span>
          <h2>
            Common questions,
            <span> clear answers.</span>
          </h2>
          <p>
            Find simple explanations about website development,
            applications, and business software solutions.
          </p>
        </div>

        <div className="abt-faq-list">
          {faqs.map(({ q, a }, index) => (
            <details className="abt-faq-item" key={q} open={index === 0}>
              <summary>
                <span className="abt-faq-num">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <span className="abt-faq-question">{q}</span>
                <span className="abt-faq-plus" aria-hidden="true" />
              </summary>
              <p>{a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

function AboutCTA() {
  return (
    <section className="abt-cta">
      <div className="abt-cta-inner">
        <div>
          <span className="abt-cta-eyebrow">LET&apos;S WORK TOGETHER</span>
          <h2>Let&apos;s Build Something Better</h2>
          <p>Have a business idea or a technology challenge?</p>
          <p>
            Talk to Hallef Technologies and find the right digital
            solution for your business.
          </p>
        </div>

        <a className="abt-cta-btn" href="/inquiry">
          Contact Us <FaArrowRight />
        </a>
      </div>
    </section>
  );
}

export default function App() {
  return (
    <>
      <Header />
      <main className="abt-page">
        <AboutIntro />
        <VisionMission />
        <FAQ />
        <AboutCTA />
      </main>
      <Footer />
    </>
  );
}
